import { compareReducer } from '../../compare/reducers/CompareReducer';
import compareSaga from '../../compare/sagas/CompareSagas';
const loadCompareModule = () => ({
    id: 'Compare',
    reducerMap: {
        compare: compareReducer,
    },
    sagas: [compareSaga],
});
export default loadCompareModule;
